export default class TimeoutTrackingService {
    constructor(configService) {
        this.inactivityResets = [];
        this.lastCustomerInteraction = 0;
        this.userActivityCheckInterval = 10000; // ms
        this.configService = configService;
    }
    setupIdleTimeoutWarning(callBack, secondsBeforeDisconnect) {
        this.secondsBeforeDisconnect = secondsBeforeDisconnect;
        this.idleWarningCallBack = callBack;
        this.resetIdleTimeout();
    }
    resetIdleTimeout() {
        if (this.idleTimeout) {
            clearTimeout(this.idleTimeout);
        }
        this.startIdleWarningTimer();
        this.updateLastInteractionTime();
    }
    startIdleWarningTimer() {
        if (this.idleWarningCallBack && this.secondsBeforeDisconnect) {
            this.idleTimeout = setTimeout(this.idleWarningCallBack, (this.configService.config.inactivityTimeout - this.secondsBeforeDisconnect) * 1000);
        }
    }
    updateLastInteractionTime() {
        this.lastCustomerInteraction = Date.now();
    }
    /**
     * Scheduler for reporting customer activity
     */
    startUserActivityTracking() {
        this.clearUserActivityTrackingInterval();
        this.userActivityScheduler = setInterval(() => {
            const currentTime = Date.now();
            if (currentTime - this.lastCustomerInteraction <= this.userActivityCheckInterval) {
                this.inactivityResets.forEach((callback) => callback());
            }
        }, this.userActivityCheckInterval);
    }
    clearUserActivityTrackingInterval() {
        clearInterval(this.userActivityScheduler);
        this.lastCustomerInteraction = 0;
    }
    registerInactivityResetCallback(callback) {
        this.inactivityResets.push(callback);
    }
}
//# sourceMappingURL=timeout-tracking-service.js.map